import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import './Contact.css';
import { siteConfig } from '../data/siteData';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    projectType: '',
    budget: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({ submitted: false, error: false });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("http://localhost:5000/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: `
Phone: ${formData.phone}
Project Type: ${formData.projectType}
Budget: ${formData.budget}
Message: ${formData.message}
          `
        })
      });

      if (response.ok) {
        setFormStatus({ submitted: true, error: false });
        setTimeout(() => {
          setFormData({ name: '', email: '', phone: '', projectType: '', budget: '', message: '' });
          setFormStatus({ submitted: false, error: false });
        }, 3000);
      } else {
        setFormStatus({ submitted: false, error: true });
      }
    } catch (error) {
      console.error("Error:", error);
      setFormStatus({ submitted: false, error: true });
    }
  };

  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  return (
    <div className="contact-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Contact Us</h1>
            <p>Let's Start Building Your Dream Project</p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section className="contact-main-section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Information */}
            <motion.div {...fadeInUp} className="contact-info-wrapper">
              <h2>Get in Touch</h2>
              <p className="contact-intro">
                Have questions about our services? Ready to start your construction project? 
                We're here to help. Reach out to us using any of the methods below.
              </p>

              <div className="contact-info-cards">
                <div className="contact-info-card">
                  <div className="contact-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-details">
                    <h3>Phone</h3>
                    <a href={`tel:${siteConfig.phone}`}>{siteConfig.phone}</a>
                    <p>Mon-Fri: 8AM - 6PM</p>
                  </div>
                </div>

                <div className="contact-info-card">
                  <div className="contact-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-details">
                    <h3>Email</h3>
                    <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a>
                    <p>We'll respond within 24 hours</p>
                  </div>
                </div>

                <div className="contact-info-card">
                  <div className="contact-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="contact-details">
                    <h3>Office</h3>
                    <p>{siteConfig.address}</p>
                  </div>
                </div>
              </div>

              <div className="contact-social">
                <h3>Follow Us</h3>
                <div className="social-icons">
                  <a href={siteConfig.socialMedia.facebook} target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                  <a href={siteConfig.socialMedia.twitter} target="_blank" rel="noopener noreferrer">
                    <FaTwitter />
                  </a>
                  <a href={siteConfig.socialMedia.linkedin} target="_blank" rel="noopener noreferrer">
                    <FaLinkedinIn />
                  </a>
                  <a href={siteConfig.socialMedia.instagram} target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </div>
              </div>
            </motion.div>

            {/* Contact Form */}
            <motion.div 
              {...fadeInUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="contact-form-wrapper"
            >
              <h2>Send Us a Message</h2>
              
              {formStatus.submitted ? (
                <div className="form-success-message">
                  <div className="success-icon">✓</div>
                  <h3>Thank You!</h3>
                  <p>Your message has been sent successfully. We'll get back to you soon!</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">

                  {formStatus.error && (
                    <div style={{ color: 'red', marginBottom: '10px' }}>
                      Something went wrong. Please try again.
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Enter Your Name"
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email">Email Address *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="Enter Your Email ID"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="phone">Phone Number *</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="Phone number"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="projectType">Project Type *</label>
                      <select
                        id="projectType"
                        name="projectType"
                        value={formData.projectType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Project Type</option>
                        <option value="Residential">Residential</option>
                        <option value="Commercial">Commercial</option>
                        <option value="Industrial">Industrial</option>
                        <option value="Renovation">Renovation</option>
                        <option value="Consultation">Consultation</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="budget">Budget Range</label>
                      <select
                        id="budget"
                        name="budget"
                        value={formData.budget}
                        onChange={handleChange}
                      >
                        <option value="">Select Budget Range</option>
                        <option value="Under 50K">Under 50K</option>
                        <option value="10-15L">10 - 15L</option>
                        <option value="20-40L">20 - 40L</option>
                        <option value="250K - 500K">250K - 500K</option>
                        <option value="$500K+">$500K+</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Project Details *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Tell us about your project..."
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary btn-large btn-block">
                    Send Message
                  </button>
                </form>
              )}
            </motion.div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="map-wrapper">
          <iframe
            title="Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.2219901290355!2d-74.00369368400567!3d40.71277937933185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a316e5d1c4f%3A0x9c2d6f372d9b8f3e!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      {/* CTA Section */}
      <section className="contact-cta bg-light">
        <div className="container">
          <motion.div {...fadeInUp} className="contact-cta-content">
            <h2>Ready to Start Your Project?</h2>
            <p>
              We're excited to help bring your construction vision to life. 
              Contact us today for a free consultation and quote.
            </p>
            <a href={`tel:${siteConfig.phone}`} className="btn btn-primary btn-large">
              Call Us Now: {siteConfig.phone}
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;